export default __webpack_public_path__ + "static/media/carbs.95581ba1.svg";